import { addDays, format, parseISO } from "date-fns";

export const TZ = "Australia/Brisbane";
export const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const todayBne = () => new Date().toLocaleDateString("en-CA", { timeZone: TZ });
export const shiftDay = (iso, n) => format(addDays(parseISO(`${iso}T12:00:00`), n), "yyyy-MM-dd");

export const PRESETS = [
  { key: "all", label: "All time" },
  { key: "today", label: "Today", days: 0 },
  { key: "7d", label: "7d", days: 6 },
  { key: "30d", label: "30d", days: 29 },
  { key: "90d", label: "90d", days: 89 },
];

export function presetRange(key) {
  const p = PRESETS.find((x) => x.key === key) || PRESETS[0];
  const end = todayBne();
  return { preset: p.key, start: p.key === "all" ? null : shiftDay(end, -p.days), end };
}

export const spanDays = (r) => !r.start ? Infinity : Math.round((parseISO(`${r.end}T12:00:00`) - parseISO(`${r.start}T12:00:00`)) / 86400000) + 1;

export function hourLabel(h) {
  const ampm = h < 12 ? "am" : "pm";
  const n = h % 12 === 0 ? 12 : h % 12;
  return `${n}${ampm}`;
}

export function bucketLabel(bucket, hourly) {
  if (!hourly) return format(parseISO(`${bucket}T12:00:00`), "d MMM");
  const [d, t] = bucket.split(" ");
  return `${format(parseISO(`${d}T12:00:00`), "d MMM")} ${hourLabel(Number(t.slice(0, 2)))}`;
}

export const rangeLabel = (r) =>
  r.start === r.end ? format(parseISO(`${r.start}T12:00:00`), "d MMM yyyy")
    : `${format(parseISO(`${r.start}T12:00:00`), "d MMM")} – ${format(parseISO(`${r.end}T12:00:00`), "d MMM yyyy")}`;

export const tooltipStyle = {
  contentStyle: { backgroundColor: "#0F0F0F", border: "1px solid #262626", borderRadius: 8, boxShadow: "0 10px 25px -5px rgba(0,0,0,0.8)", fontSize: 12 },
  labelStyle: { color: "#fff", fontWeight: 600, marginBottom: 4 },
  itemStyle: { color: "#d4d4d4", padding: 0 },
  cursor: { fill: "rgba(255,255,255,0.03)" },
};

export function Panel({ title, aside, children, className = "", testid }) {
  return (
    <section data-testid={testid} className={`bg-[#0F0F0F] border border-neutral-800 rounded-xl p-5 ${className}`}>
      <div className="flex items-center justify-between gap-3 mb-4">
        <h2 className="text-sm font-heading font-semibold text-neutral-200 uppercase tracking-wider">{title}</h2>
        {aside}
      </div>
      {children}
    </section>
  );
}
